(function () {
  'use strict';
  if (window.YVCouponWallet) return;
  var PREFIX = 'yv-coupon-wallet-v1:', LIMIT = 60, DAY = 86400000;
  var memory = Object.create(null), unsaved = Object.create(null);
  var shopClock = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function emailKey(value) {
    var email = typeof value === 'string' ? value.trim().toLowerCase() : '';
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
  }
  function readJSON(key) {
    try { return JSON.parse(window.localStorage.getItem(key)); } catch (e) { return null; }
  }
  function shopParts(at) {
    var result = {};
    shopClock.formatToParts(new Date(at)).forEach(function (part) { result[part.type] = part.value; });
    return result;
  }
  function isoDay(at) { return new Date(at).toISOString().slice(0, 10); }
  function validDay(value) {
    if (typeof value !== 'string' || !/^20\d{2}-\d{2}-\d{2}$/.test(value)) return false;
    var at = Date.parse(value + 'T00:00:00Z');
    return Number.isFinite(at) && isoDay(at) === value;
  }
  function inferDay(claim, code, at) {
    var mmdd = code.split('-')[1];
    if (validDay(claim.shopDate) && claim.shopDate.slice(5).replace('-', '') === mmdd) return claim.shopDate;
    var year = Number(shopParts(at).year), best = null;
    for (var y = year - 1; y <= year + 1; y++) {
      var day = y + '-' + mmdd.slice(0, 2) + '-' + mmdd.slice(2);
      if (!validDay(day)) continue;
      var distance = Math.abs(Date.parse(day + 'T12:00:00Z') - at);
      if (!best || distance < best.distance) best = { day: day, distance: distance };
    }
    return best ? best.day : null;
  }
  function expiryFor(day) {
    var target = Date.parse(day + 'T00:00:00Z') + 8 * DAY;
    var instant = target;
    for (var i = 0; i < 3; i++) {
      var p = shopParts(instant);
      var wall = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      instant += target - wall;
    }
    return instant - 1000;
  }
  function normalize(claim) {
    if (!claim || typeof claim !== 'object' || claim.golden || claim.fallback) return null;
    var email = emailKey(claim.email), code = typeof claim.code === 'string' ? claim.code.trim().toUpperCase() : '';
    if (!email || (code !== 'FEELING10' && !/^LB(?:10|15|SHIP)-\d{4}-[A-Z0-9]{4,32}$/.test(code))) return null;
    var at = Number(claim.at);
    if (!Number.isFinite(at) || at < 946684800000 || at > Date.now() + DAY) at = Date.now();
    if (code === 'FEELING10') return { email: email, code: code, at: at, shopDate: null, expiresAt: null };
    var day = inferDay(claim, code, at);
    if (!day) return null;
    return { email: email, code: code, at: at, shopDate: day, expiresAt: expiryFor(day) };
  }
  function records(email) {
    var key = PREFIX + encodeURIComponent(email);
    var saved = readJSON(key);
    var list = unsaved[key] ? (memory[key] || []) : (Array.isArray(saved) ? saved : (memory[key] || []));
    return list.map(normalize).filter(function (entry) { return entry && entry.email === email; });
  }
  function remember(claim) {
    var entry = normalize(claim);
    if (!entry) return false;
    var key = PREFIX + encodeURIComponent(entry.email);
    var list = records(entry.email).filter(function (item) { return item.code !== entry.code; });
    list.push(entry);
    list.sort(function (a, b) { return b.at - a.at; });
    list = list.slice(0, LIMIT);
    memory[key] = list;
    try { window.localStorage.setItem(key, JSON.stringify(list)); unsaved[key] = false; } catch (e) { unsaved[key] = true; }
    render();
    return true;
  }
  function restoreLegacy() {
    var box = readJSON('yv-luckybox');
    if (box && box.claimed && typeof box.claimed === 'object') {
      var claim = Object.assign({}, box.claimed);
      if (!claim.shopDate && box.dayPrize && box.dayPrize.code === claim.code) claim.shopDate = box.dayPrize.shopDate;
      var owner = emailKey(claim.email);
      if (!records(owner).some(function (entry) { return entry.code === String(claim.code || '').toUpperCase(); })) remember(claim);
    }
    var profile = readJSON('yv-quiz-profile');
    if (profile && profile.email && !records(emailKey(profile.email)).some(function (entry) { return entry.code === 'FEELING10'; })) {
      remember({ email: profile.email, code: 'FEELING10', at: profile.at || profile.savedAt });
    }
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function copyCode(button, code, copy) {
    function done() { button.textContent = copy.copied; window.setTimeout(function () { button.textContent = copy.copy; }, 1400); }
    function failed() { button.textContent = copy.copy_failed; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, failed);
    } else {
      var input = element('textarea');
      input.value = code;
      document.body.appendChild(input);
      input.select();
      try { if (document.execCommand('copy')) done(); else failed(); } catch (e) { failed(); }
      input.remove();
    }
  }
  function updateTimer(timer) {
    var copy = timer._yvCouponCopy;
    if (!copy) return;
    var expiresAt = Number(timer.getAttribute('data-local-exp'));
    var left = expiresAt - Date.now();
    if (left <= 0) {
      timer.textContent = copy.expired;
      var card = timer.closest('[data-local-coupon]');
      if (card) {
        card.classList.add('is-expired');
        var button = card.querySelector('[data-local-copy]');
        if (button) button.remove();
      }
      return;
    }
    var mins = Math.ceil(left / 60000), days = Math.floor(mins / 1440), hours = Math.floor((mins % 1440) / 60);
    timer.textContent = (days ? copy.days_left : (hours ? copy.hours_left : copy.minutes_left)).replace('[days]', days).replace('[hours]', hours).replace('[minutes]', mins % 60);
  }
  function cardFor(entry, copy) {
    var expired = entry.expiresAt != null && entry.expiresAt <= Date.now();
    var card = element('article', 'yv-coupon' + (expired ? ' is-expired' : ''));
    card.setAttribute('data-local-coupon', entry.code);
    var main = element('div', 'yv-coupon__main');
    var title = entry.code === 'FEELING10' ? copy.quiz_title : (entry.code.indexOf('LBSHIP-') === 0 ? copy.shipping : (entry.code.indexOf('LB15-') === 0 ? copy.fifteen_off : copy.ten_off));
    main.appendChild(element('p', 'yv-coupon__prize', title));
    main.appendChild(element('p', 'yv-coupon__code', entry.code));
    main.appendChild(element('p', 'yv-coupon__meta', copy.saved_browser + ' · ' + (entry.shopDate ? copy.lucky_box + ' ' + entry.shopDate : copy.quiz_reward)));
    var side = element('div', 'yv-coupon__side');
    var timer = element('p', 'yv-coupon__timer', copy.no_expiry);
    if (entry.expiresAt != null) {
      timer.setAttribute('data-local-exp', String(entry.expiresAt));
      timer.title = copy.expires_at.replace('[date]', isoDay(Date.parse(entry.shopDate + 'T00:00:00Z') + 7 * DAY));
      timer._yvCouponCopy = copy;
    }
    side.appendChild(timer);
    if (!expired) {
      var button = element('button', 'yv-coupon__copy', copy.copy);
      button.type = 'button';
      button.setAttribute('data-local-copy', entry.code);
      button.addEventListener('click', function () { copyCode(button, entry.code, copy); });
      side.appendChild(button);
    }
    card.appendChild(main);
    card.appendChild(side);
    if (entry.expiresAt != null) updateTimer(timer);
    return card;
  }
  function render() {
    document.querySelectorAll('[data-coupon-wallet]').forEach(function (wallet) {
      var email = emailKey(wallet.getAttribute('data-customer-email'));
      var host = wallet.querySelector('[data-local-coupons]');
      if (!host) return;
      host.replaceChildren();
      if (!email) return;
      var copyNode = wallet.querySelector('[data-coupon-strings]'), copy;
      try { copy = JSON.parse(copyNode.textContent); } catch (e) { return; }
      var serverCodes = Object.create(null);
      wallet.querySelectorAll('.yv-coupon__code').forEach(function (node) { serverCodes[node.textContent.trim().toUpperCase()] = true; });
      var list = records(email).filter(function (entry) { return !serverCodes[entry.code]; });
      if (list.length) {
        host.appendChild(element('h2', 'yv-coupons__h', copy.saved_rewards));
        list.forEach(function (entry) { host.appendChild(cardFor(entry, copy)); });
      }
      var empty = wallet.querySelector('.yv-coupons-empty');
      if (empty) empty.hidden = list.length > 0 || wallet.querySelector('[data-coupon-card]:not(.yv-coupon--locked)') !== null;
    });
  }
  window.YVCouponWallet = { remember: remember, restoreLegacy: restoreLegacy, render: render };
  function boot() { restoreLegacy(); render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('storage', function (event) {
    if (!event.key || event.key.indexOf(PREFIX) === 0 || event.key === 'yv-luckybox' || event.key === 'yv-quiz-profile') boot();
  });
  window.setInterval(function () { document.querySelectorAll('[data-local-exp]').forEach(updateTimer); }, 30000);
})();
